import React from 'react';
import Portfolio from '../Components/Home/Portfolio';

const PortfolioPage = () => {
    // const portfolio = 333;
    return (
        <div>
            {/* <h1>PortfolioPage{portfolio}</h1> */}
            <Portfolio/>
        </div>
    );
};

export default PortfolioPage;
